( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-card-carousel').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const sliderFull = $(sliderEl).hasClass('swiper--full');
			const navParent = $('.js-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 33,
				slidesPerView: 1.1,
				loop: false,

				breakpoints: {
					600: {
						spaceBetween: 40,
						slidesPerView: 'auto',
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				pagination: {
					el: $('.js-carousel-nav-pagination', carousel)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				on: {
					beforeInit: function () {
						let numSlides = $('.js-carousel-slide', carousel).length;
						if ( numSlides <= 4 ) {
							this.params.loop = false;
						}

						if (numSlides <= 1) {
							navParent.css('display', 'none');
						}
					}
				}
			});
		});
	});
} )( jQuery, document, window );
